import { heroQuick, heroSeals } from "@/mocks/heiliao";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="mx-auto grid w-full max-w-[1240px] grid-cols-1 items-center gap-8 px-4 pb-12 pt-28 md:gap-10 md:px-6 md:pt-32 lg:grid-cols-[1.15fr_0.85fr] lg:pb-16">
        <div className="flex flex-col">
          <div className="mb-5 flex flex-wrap items-center gap-2">
            <span className="whitespace-nowrap rounded-full bg-primary-50 px-3 py-1 text-xs font-bold text-primary-700">
              <i className="ri-flag-fill mr-1"></i>今日有 4 起新进展
            </span>
            <span className="whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-900">
              <i className="ri-alert-fill mr-1"></i>2 起正在反转
            </span>
          </div>

          <h1 className="font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            吃瓜可以，
            <br />
            但得先有<span className="text-primary-600">锤</span>。
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            不能只看表面。我们把实锤证据、截图石锤、录音视频和原帖存档，按时间线一条条梳理清楚，
            再把细节对比摆出来——让你快速看清事件全貌，判断真假不再靠猜。
          </p>

          <form
            className="mt-7 flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:items-center"
            onSubmit={(e) => e.preventDefault()}
          >
            <label className="relative flex-1">
              <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-foreground-400"></i>
              <input
                type="text"
                placeholder="搜一个人名 / 事件 / 话题，看有没有锤"
                className="w-full rounded-full border border-background-300 bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300"
              />
            </label>
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              查实一下
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center gap-2">
            <span className="text-xs text-foreground-400">本页提供：</span>
            {heroSeals.map((s) => (
              <span
                key={s.text}
                className="flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900"
              >
                <i className={s.icon}></i>
                {s.text}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            {heroQuick.map((q) => (
              <div
                key={q.label}
                className="rounded-lg border border-background-200 bg-background-100 px-4 py-3"
              >
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-2xl font-black text-primary-600">{q.num}</span>
                  <span className="text-xs text-foreground-500">{q.unit}</span>
                </div>
                <div className="mt-0.5 text-xs text-foreground-500">{q.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative flex items-center justify-center">
          <div className="relative w-full max-w-md overflow-hidden rounded-xl border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=A%20tall%20editorial%20visual%20of%20a%20forensic%20investigation%20mood%20board%20with%20pinned%20evidence%20photos%20documents%20red%20seal%20stamps%20magnifier%20and%20typewritten%20labels%20on%20warm%20cream%20paper%2C%20dramatic%20but%20soft%20light%2C%20muted%20beige%20with%20crimson%20and%20amber%20accents%2C%20no%20faces%2C%20documentary%20art%20direction%2C%20rich%20detail&width=880&height=1080&seq=hero-side-01&orientation=portrait"
              alt="黑料实锤证据素材墙示意"
              title="黑料实锤证据素材墙示意"
              className="h-full w-full object-cover"
            />
            <div className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-foreground-950/70 px-3 py-1 text-xs text-background-50 backdrop-blur">
              <i className="ri-folder-3-fill text-accent-400"></i>本周档案 · 收录 31 份
            </div>
          </div>
          <span className="absolute -bottom-4 -left-2 rotate-[-8deg] rounded-md bg-accent-500 px-3 py-1 font-heading text-sm font-black text-foreground-950 shadow-none md:-left-4">
            只放能对上号的证据
          </span>
        </div>
      </div>
    </section>
  );
}